<template>
  <div class="quickly scroll_bar">
    <div class="quicklytag" v-for="(item, index) of list" :key="index">
    
      <span class="tagbtn" v-if="item.menuType !== 7 && item.menuType !== 1&& item.menuType !== 5 || (item.menuType === 5 && work == '0')">
        <div @click="choose(item)" class="bluefont">
          <img height="14" :src="item.menuType == 0 ?
              flyh : item.menuType == 6 ?
                gw : item.menuType == 3 ?
                  '' : item.menuType == 8 ?
                    rdcp : item.menuType == 5 ?
                      ly : item.menuType == 7 ?
                        fswj : pj

            " align="absmiddle">
          <a class="menufont">{{ item.menuName }}</a>
        </div>

      </span>
      <span class="tagbtn" v-if="item.menuType == 1 && work == '1'">
        <div @click="choose(item)" class="bluefont">
          <img height="14" :src="zrg" align="absmiddle">
          <a class="menufont">{{ item.menuName }}</a>
        </div>
      </span>
      <span class="tagbtn" v-if="item.menuType == 7">
        <div class="bluefont">
          <img height="14" :src="fswj" alt="" align="absmiddle">
          <a class="menufont">{{ item.menuName }}</a>
          <input title="支持上传.png,.jpeg,.jpg,.bmp,.gif,.xls,.xlsx,.doc,.docx,.txt,.pdf,.csv,.odf,.ppt,.pptx 格式文件" @change="changeFile" accept=".png,.jpeg,.jpg,.bmp,.gif,.xls,.xlsx,.doc,.docx,.txt,.pdf,.csv,.odf,.ppt,.pptx" type="file" ref="input_file">
        </div>
      </span>
    </div>
    <el-dialog class="dialogtips" title="确认信息" :append-to-body="true" :visible.sync="addDialog" width="520px" top="14%">

      <el-form label-position="right">

        <p class="tips">点击“确定”按钮可与客服人员交谈，若对下列信息处理和保存、保护方式等有疑问，请您查阅我司官网披露的“隐私政策”；或点击“跳过”按钮以匿名身份与客服人员交谈。</p>
        <el-form-item label="客户姓名">
          <el-input v-model="name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="phone" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button :style="{ backgroundColor: initData.kitBgcolor }" type="primary" @click="pass">跳 过</el-button>
        <el-button :style="{ backgroundColor: initData.kitBgcolor }" type="primary" @click="transfer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import urlParams from "../../api/urlParams";
import chatApi from "../methods";
import store from "../../store";
import request from "../../api/request";
import zrg from '../../../static/image/damo/zrg.png'
import fswj from '../../../static/image/damo/fswj.png'

import flyh from '../../../static/image/damo/flyh.png'
import gw from '../../../static/image/damo/gw.png'
import rdcp from '../../../static/image/damo/rdcp.png'
import ly from '../../../static/image/damo/ly.png'
import pj from '../../../static/image/damo/pj.png'

export default {
  name: "side",
  data() {
    return {
      sideShow: true,
      zrg:zrg,
      fswj:fswj,
        flyh:flyh,
          gw:gw,
            rdcp:rdcp,
              ly:ly,
                pj:pj,
      list: [],
      isIframe: false,
      addDialog: false,
      name: "",
      phone: "",
      work: 1
    }
  },
  watch: {
    initData() {
      return this.$store.state.initData;
    },
    connectStatus() {
      setTimeout(()=>{
       this.isworkfn();
    },500)

      return this.$store.state.connectStatus
    }
  },
  computed: {
    initData() {
      return this.$store.state.initData;
    },
    customer() {
      return this.$store.state.customer;
    },
    connectStatus() {
      return this.$store.state.connectStatus
    },
    userInfo() {

      return this.$store.state.userInfo;

    },
  },
  mounted() {
    if (urlParams("from") === "iframe") {
      this.isIframe = true;
    }
    this.isworkfn()
   
  },
  methods: {
    choose(item) {
      if (item.menuType == 0 || item.menuType == 8) {
        const obj = {
          docId: item.docId,
          click: 1,
          msgContent: item.msgText,
          senderType: 1, // 发送人 1用户，2客服，3机器人
          date: new Date().getTime(),
          msgType: 1, // 消息类型 1文本
          status: "loading", // 消息状态 成功后隐藏否则一直loading
          id: "message" + new Date().getTime(),
        };
        // 更新聊天消息
        this.$store.dispatch("setChatList", obj);
        chatApi.sendMessage(obj);
      } else if (item.menuType == 6) {
        window.open(item.labelLink, "_blank");
      } else if (item.menuType == 3) {
        chatApi.closeChatSession();
      } else if (item.menuType == 4) {
        if (this.$store.state.enableEvaluate) {
          chatApi.getEvaluateMsg(() => {
            this.$store.dispatch("setConfigPc", [
              { key: "showModal", value: true },
              {
                key: "evaluateModal",
                value: true,
              },
            ]);
          });
        } else {
          let obj = {
            senderType: 4, // 消息类型 1文本
            msgContent: this.$t("chatAfterEva"),
          };
          this.$store.dispatch("setChatList", obj);
          this.$store.dispatch("setScrollBottom");
        }
      } else if (item.menuType == 1) {
        this.addDialog = true;
        // chatApi.chatForm();
      } else {
        // this.$store.dispatch("setConfigPc", [
        //   { key: "showModal", value: true },
        //   { key: "messageModal", value: true },
        // ]);
        if (this.isIframe) {
          this.$router.push(
            "/leaveMessage" +
            "?channelId=" +
            this.$route.query.channelId +
            "&tenantId=" +
            store.state.initData.tenantId +
            "&userId=" +
            store.state.userInfo.userId +
            "&from=iframe"
          );
        } else {
          this.$router.push(
            "/leaveMsg" +
            "?channelId=" +
            this.$route.query.channelId +
            "&tenantId=" +
            store.state.initData.tenantId +
            "&userId=" +
            store.state.userInfo.userId
          );
        }
      }
    },
    // 转人工
    transfer() {
      request
        .getUser({
          name: this.name,
          phone: this.phone,
        })
        .then((res) => {
          if (res.data) {
            request
              .updateUserInfo({
                customerId: res.data.customerId,
                userId: this.userInfo.userId,
                userName: this.name,
                userPhone: this.phone,
              })
              .then(() => {
                this.addDialog = false;
                chatApi.transfer();
              });
          } else {
            this.addDialog = false;
            chatApi.transfer();
          }
        });
    },
    pass() {
      this.addDialog = false;
      chatApi.transfer();
    },
    changeFile(file) {
      const files = file.target.files[0]; //获取文件
      let name = files.name;
      let i = name.lastIndexOf('.')
      if(i !== -1){
        let type = name.slice(i).toLowerCase();
        let str = '.png,.jpeg,.jpg,.bmp,.gif,.xls,.xlsx,.doc,.docx,.txt,.pdf,.csv,.odf,.ppt,.pptx';
        if(str.indexOf(type) > -1){
          chatApi.uploadFile(files);
          setTimeout(() => {
            this.$refs.input_file.value = '';
          }, 1000)
        }else{
          this.$message({
          type: "error",
          message: '文件格式有误！',
        });
        }
      }
      
    },
    isworkfn() {
      if(!this.$store.state.userInfo.userId){return}
       request.isWork({
         userId: this.$store.state.userInfo.userId || ''
       }).then(res => {
         this.work = res.data;
         if (this.$store.state.initData.chatMenuConfigPlan) {
        this.list = this.$store.state.initData.chatMenuConfigPlan.chatMenuConfigList || [];
      }

      if (this.$store.state.initData.transferUserMode) {
        this.list = this.list.filter((item) => {
          return item.menuType != 1;
        });
        this.list.unshift(
          {
            menuType: 1,
            menuName: this.$t("transform")
          }
        )

      }

      if (this.$store.state.connectStatus == 'manual') {
        this.list = this.list.filter((item) => {
          return item.menuType !== 1;
        });
        this.list = this.list.filter((item) => {
          return item.menuType !== 5;
        });
      } else {
        this.list = this.list.filter((item) => {
          return item.menuType !== 7;
        });
      }
       })
    }
  }
}
</script>

<style scoped>
.quickly {
  width: 100%;
  height: 50px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: #fff;
  overflow-y: hidden;
  overflow-x: scroll;
  display: flex;
  touch-action: pan-x;
  scrollbar-width: none;
  /*Firefox*/
  -ms-overflow-style: none;
  /*IE10+*/
  border: none;
}


.quickly::-webkit-scrollbar {
  height: 0.6px;
  width: 1px;
  /* display: none; */
}

.quicklytag {
  display: inline-flex;
  white-space: nowrap;
  touch-action: pan-x;
}

.quickly span {
  height: 30px;
  background: #FFFFFF;
  /* border-radius: 16px; */
  /* border: 1px solid #E0E0E0; */
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 400;
  /* color: #0AA4E2; */
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  margin-right: 10px;
  margin-right: 10px;
  float: left;
  margin-top: 10px;
  box-shadow: 0px 0px 5px rgba(0, 11, 48, 0.08);
}

.bluefont {
  color: rgb(10, 164, 226);
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: justify;
}


.tagbtn {
  position: relative;
}

.tagbtn input {
  position: absolute;
  left: 0;
  top: 0;
  width: 80px;
  height: 30px;
  opacity: 0;
}

.mr5 {
  margin-right: 5px;
}

img {
  vertical-align: top;
}

.tips {
  color: #bebebe;
  font-size: 12px;
  margin-bottom: 10px;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
}

.dialogtips /deep/ .el-dialog__body {
  padding: 5px 20px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/quicklty.vue